
export default {
  data() {
    return {
      isCalendlyActive: false,
      argument: {
        titleArgument: `Vos publicités en <span class="font-clash font-bold text-purple-brand">pilotage automatique</span>`,
        surtitle: "Aleo, votre agence social media",
        webArguments: [
          {
            title: "Retour sur investissement",
            text: "Communiquez efficacement avec une solution focalisée sur votre retour sur investissement.",
            img: require("~/assets/img/picto-flex.svg"),
            alt: "Retour sur investissement",
          },
          {
            title: "Expertise",
            text: "Développez votre notoriété avec des publicités professionnelles gérées par un expert en acquisition sur les réseaux sociaux.",
            img: require("~/assets/img/picto-pc.svg"),
            alt: "Expertise",
          },
          {
            title: "Stratégie",
            text: "Atteignez vos objectifs avec une stratégie conçue sur-mesure pour votre entreprise et pilotée par un chargé de projet ALEO.",
            img: require("~/assets/img/picto-medal.svg"),
            alt: "Stratégie",
          },
        ],
      },
      arguments2: [
        {
          img: "argument-ad-1.png",
          title: "Vos objectifs avant tout",
          text: "Générer des contacts, développer votre notoriété, attirer des abonnés, notre équipe s’occupe de tout pour atteindre vos objectifs.",
          alt: "Vos objectifs avant tout",
        },
        {
          img: "argument-web-2.png",
          title: "Un accompagnement flexible",
          text: "Création de visuels, ciblage des utilisateurs, phases de test, nous mettons en place la formule la mieux adaptée à votre succès !",
          alt: "Un accompagnement flexible",
        },
        {
          img: "argument-ad-2.png",
          title: "Un suivi rigoureux",
          text: "Suivez facilement les résultats de vos publicités et bénéficiez d’un accompagnement sur mesure.",
          alt: "Un suivi rigoureux",
        },
      ],
      reviewCollab: {
        author: "Maeva - Social Media Manager",
        text: "Je multiplie vos opportunités grâce à la publicité",
        img: "Maeva.png",
        alt: "Expert Facebook Ads",
      },

      itemsList: [
        {
          title: "Multipliez vos opportunités commerciales",
        },
        {
          title: "Boostez votre visibilité",
        },
        {
          title: "Améliorez votre crédibilité en ligne",
        },
        {
          title: "Maîtrisez votre budget publicitaire",
        },
        {
          title: "Analysez vos résultats accompagné par un expert",
        },
      ],
      price: {
        price: 250,
        text: "Transformez la manière dont vous attirez des clients.",
        engagement: "6 mois d'engagement",
      },

      timeline: {
        surtitle: "",
        title: `Comment ça marche&nbsp;?`,
        steps: [
          {
            img: "seo-step-1.png",
            title: "Stratégie",
            text: "Chaque projet est différent, avec des objectifs différents. Nous analysons votre activité et définissons une stratégie sur mesure.",
            alt: "Stratégie",
          },
          {
            img: "web-step-2.png",
            title: "Création publicitaire",
            text: "Nos équipes réfléchissent et conçoivent des campagnes publicitaires impactantes pour marquer les esprits de vos clients.",
            alt: "Création publicitaire",
          },
          {
            img: "web-step-3.png",
            title: "Diffusion",
            text: "Nous diffusons vos publicités aux bonnes personnes pour atteindre vos objectifs.",
            alt: "Diffusion",
          },
          {
            img: "web-step-4.png",
            title: "Amélioration continue",
            text: "Nous testons différentes variations sur les visuels, les accroches et le ciblage publicitaire pour maximiser votre retour sur investissement.",
            alt: "Amélioration continue",
          },
          {
            img: "web-step-5.png",
            title: "Suivi et accompagnement",
            text: "Nos équipes vous accompagnent pour améliorer votre ROI et vous aident à comprendre les résultats de vos campagnes publicitaires.",
            alt: "Suivi et accompagnement",
          },
        ],
      },

      reviews: [
        {
          text: "Une belle communication avec beaucoup de professionnalisme.",
          author: "Met'Propre Nettoyage",
        },
        {
          text: "L'équipe ALEO a su parfaitement répondre à mes attentes !",
          author: "Entreprise CCZ",
        },
        {
          text: "Je suis très satisfait de ma collaboration avec cette agence : les visuels sont d'une grande qualité et la graphiste en charge de mon dossier est à l'écoute et réactive.",
          author: "AUTO-ÉCOLE NOTRE DAME",
        },
        {
          text: "Equipe sympathique. La créativité sur les publications est top ! J'apprécie le fait qu'on nous demande si on a du contenu à mettre en avant, ça permet d'être au plus proche de notre métier. Je suis satisfaite.",
          author: "LAURENCE FERRY",
        },
      ],

      faq: [
        {
          question:
            "Comment est mise en place ma stratégie de communication Facebook et Instagram ?",
          answer: `<p class="pb-4">Chez ALEO, nous établissons votre stratégie marketing sur les <strong>médias sociaux</strong>, en particulier <strong>Facebook et Instagram</strong>, en quatre étapes essentielles. Nous commençons par assurer l'accès à vos plateformes et concevoir votre page Facebook si nécessaire. Ensuite, un appel est programmé avec votre <strong>community manager</strong> dédié pour définir votre ligne éditoriale, en s'appuyant sur l'histoire et les enjeux de votre entreprise.</p>
  <p class="pb-4">L'étape suivante consiste à lancer votre première <strong>campagne publicitaire</strong> selon un calendrier préétabli. Cette démarche garantit une communication efficace et constante sur vos réseaux sociaux. Enfin, nous réalisons et gérons <strong>vos publicités Facebook et Instagram</strong>, en utilisant notre expertise en Facebook Ads pour atteindre et engager votre audience cible.</p>
  <p>En résumé, nous vous proposons <strong>une gestion de campagnes optimisée</strong> sur vos réseaux sociaux.</p>`,
          isCollapsed: false,
        },
        {
          question: "Proposez-vous une stratégie de contenu personnalisée ?",
          answer: `<p>Oui, nous concevons un <strong>calendrier éditorial</strong> adapté à votre action et vos <strong>objectifs publicitaires</strong>. Nous prenons en compte vos périodes de soldes, les informations que vous souhaitez mettre en avant et vos dates de fermeture pour vous créer un planning de publication personnalisé.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Pourquoi choisir une agence Facebook Ads / Instagram Ads comme ALEO ?",
          answer: `<p class="pb-4">Opter pour une <strong>agence Facebook Ads / Instagram</strong> telle qu'ALEO offre plusieurs avantages en termes de webmarketing et de gestion de vos réseaux publicitaires. Les publicitaires experts d'ALEO maîtrisent les outils spécifiques à ces plateformes, tels que le <strong>pixel Facebook</strong>, pour cibler efficacement vos <strong>prospects et maximiser le taux de conversion</strong> de vos campagnes publicitaires.</p>
  <p class="pb-4">De plus, nous assurons la <strong>création et la publication</strong> régulière de contenus attrayants, animant ainsi votre communauté de manière cohérente. Notre approche collaborative vous implique dans la validation des contenus et visuels. </p>
  <p>En bref, choisir ALEO, c'est bénéficier d'une expertise en publicité digitale tout en gardant le contrôle sur votre <strong>image de marque.</strong></p>`,
          isCollapsed: false,
        },
        {
          question:
            "Je n’ai pas de compte Facebook ou Instagram, puis-je faire appel à ALEO ?",
          answer: `<p class="pb-4">Même sans compte Facebook ou Instagram, vous pouvez faire appel aux services d'ALEO. Notre agence s'occupe de créer votre <strong>page Facebook</strong> et de vous fournir les détails pour vous y connecter. Pour Instagram, nous demandons l'accès à votre compte une fois créé pour promouvoir les <strong>publications sponsorisées.</strong></p>
  <p>Que vous soyez novice ou expérimenté dans la gestion des réseaux sociaux, nous simplifions votre <strong>communication digitale</strong> et développons votre communauté et votre notoriété.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Aidez-vous à cibler les publicités sur Facebook et Instagram ?",
          answer: `<p class="pb-4">Oui, chez ALEO, nous comprenons l'importance du ciblage pour le succès de vos publicités sur Facebook et Instagram. Nous ne nous contentons pas de créer des publicités, nous développons une <strong>stratégie de ciblage</strong> adaptée à votre activité.</p>
  <p class="pb-4">Nous travaillons à identifier et à comprendre votre <strong>public cible</strong> pour nous assurer que vos publicités atteignent les personnes les plus susceptibles d'être intéressées par vos produits ou services.</p>
  <p class="pb-4">De cette façon, nous aidons à générer du trafic pertinent vers votre site internet. En créant des <strong>campagnes publicitaires</strong> impactantes et personnalisées, nous visons à augmenter le taux de clic et la conversion de vos <strong>annonces sponsorisées</strong>.</p>
  <p class="pb-4">Que vous cherchiez à lancer une <strong>nouvelle campagne</strong> ou à <strong>optimiser une publicitaire existante</strong>, nous vous aiderons à atteindre vos objectifs.</p>
  <p class="pb-4">Notre expertise en <strong>publicité sur les réseaux sociaux</strong> nous permet de créer des campagnes adaptées à vos besoins spécifiques. </p>
  <p>Que ce soit pour augmenter la <strong>visibilité de votre marque</strong>, attirer de nouveaux clients ou stimuler les conversions, nous vous fournirons une stratégie de contenu personnalisée pour atteindre vos objectifs. De la réalisation d'une campagne jusqu'à l'<strong>analyse des résultats</strong>, nous veillons à utiliser vos ressources de manière optimale.</p>`,
          isCollapsed: false,
        },
        {
          question: "Pourquoi faire de l'Instagram Ads ou du Facebook Ads ?",
          answer: `  <p class="pb-4">Faire de la publicité sur Meta Ads (Facebook Ads et Instagram Ads) est aujourd’hui incontournable pour les entreprises.</p>
  <p class="pb-4"><strong>Facebook Ads et Instagram Ads</strong> permettent de toucher une large audience tout en offrant des options de ciblage extrêmement précises. Vous pourrez adresser vos publicités à des utilisateurs en fonction de critères comme leur âge, leur localisation ou leurs intérêts.</p>
  <p class="pb-4">Que ce soit pour accroître la visibilité de votre marque, générer des ventes ou diriger du trafic vers votre site, <strong>Meta Ads</strong> vous permet de diffuser des publicités aux meilleurs endroits pour vous faire atteindre vos objectifs.</p>
  <p class="pb-4">Pour tirer le meilleur parti de Facebook Ads et Instagram Ads, le mieux est de passer par une agence Meta Partner comme ALEO afin de maximiser votre retour sur investissement.</p>`,
          isCollapsed: false,
        },
        {
          question: "Comment faire de l'Instagram Ads ou du Facebook Ads ?",
          answer: `  <p class="pb-4">Pour lancer une campagne de publicité Facebook Ads ou Instagram Ads, vous devez accéder au gestionnaire de publicités Meta et créer une publicité. Attention, le gestionnaire de publicités est un outil complexe qui nécessite des compétences techniques spécifiques pour être utilisé à son plein potentiel.</p>
  <p class="pb-4">Pour gérer vos campagnes, il est préférable de passer par une agence META Partner telle que ALEO.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Quel budget pour faire une campagne Facebook Ads ou Instagram Ads ?",
          answer: `  <p class="pb-4">Vous pouvez faire une campagne Facebook Ads ou Instagram Ads quel que soit votre budget. Cependant, vos résultats dépendront d’autres facteurs tels que vos cibles, vos concurrents et vos objectifs publicitaires.</p>
  <p class="pb-4">Pour assurer la meilleure qualité possible pour vos campagnes de publicités sur Meta, il est conseillé de passer par une agence certifiée Meta Partner telle que ALEO, qui pourra vous proposer une stratégie complète et paramétrer vos campagnes pour obtenir le meilleur retour sur investissement possible.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Peut-on faire de la publicité pour n’importe quelle activité ?",
          answer: `  <p class="pb-4">En théorie, la publicité est possible pour de nombreux secteurs, mais Facebook et Instagram ont des règles strictes, notamment pour les produits de santé, les services financiers, les produits pour adultes, l’immobilier, l’emploi, et la <strong>politique</strong>.</p>
  <p class="pb-4">Pour savoir quelles typologies d’entreprises ALEO ne peut pas accompagner, nous vous invitons à consulter nos <strong>standards publicitaires</strong>.</p>`,
          isCollapsed: false,
        },
      ],
    };
  },
  head() {
    return {
      title: "Agence Facebook Ads et Instagram Ads | Agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Développez votre notoriété avec la publicité sur les réseaux sociaux. Fidélisez votre communauté, créez de nouvelles opportunités et gagnez en visibilité.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "ALEO, AGENCE COMMUNITY MANAGEMENT ET FACEBOOK ADS",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Développez votre notoriété avec la publicité sur les réseaux sociaux. Fidélisez votre communauté, créez de nouvelles opportunités et gagnez en visibilité.",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-rs.jpg"),
        // },
      ],
    };
  },

  methods: {
    activeCalendly() {
      this.isCalendlyActive = false;
      this.$nextTick(() => {
        this.isCalendlyActive = true;
      });
    },
  },
};
